<script setup>
import Odd from '../Odd.vue'
import { computed } from 'vue'
import newMarketsDisplay from '@/new-markets-display'

const props = defineProps({
  odds: Array,
  cols: Number,
  event: Object,
  marketId: Number,
  marketNrs: Array
})

const resolvedCols = computed(() => {
  for (const [cols, ids] of Object.entries(newMarketsDisplay)) {
    if (ids.includes(Number(props.marketId))) {
      return Number(cols)
    }
  }

  return props.cols || 2
})

const groupedOdds = computed(() => {
  const odds = props.odds || []
  if (!odds.length) return []

  const isManualLayout = Object.values(newMarketsDisplay)
    .some(ids => ids.includes(Number(props.marketId)))

  if (isManualLayout) {
    const cols = Array.from({ length: resolvedCols.value }, () => [])
    odds.forEach((odd, index) => {
      cols[index % resolvedCols.value].push(odd)
    })
    return cols
  }

  const groups = {}
  odds.forEach(odd => {
    const key = odd.c ?? 0
    if (!groups[key]) groups[key] = []
    groups[key].push(odd)
  })

  Object.keys(groups).forEach(c => {
    groups[c].sort((a, b) => (a.s ?? 0) - (b.s ?? 0))
  })

  return Object.values(groups)
})

const width = computed(() => {
  switch (resolvedCols.value) {
    case 1: return 'w-full'
    case 2: return 'w-1/2'
    case 3: return 'w-1/3'
    case 4: return 'w-1/4'
    case 5: return 'w-1/5'
    default: return 'w-1/2'
  }
})
</script>

<template>
  <div class="flex flex-wrap">
    <div
      v-for="(col, colIndex) in groupedOdds"
      :key="colIndex"
      :class="[width, 'float-left']"
    >
      <ul class="list-none">
        <li
          v-for="odd in col"
          :key="odd.i"
          class="OddsListItem"
        >
          <Odd
            :odd="odd"
            :with-name="true"
            :event="event"
            :mi="marketId"
            :mnrs="marketNrs"
            class="py-2.5"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
